module.exports = __webpack_public_path__ + "static/media/clients_off@2x.db8938fb.svg";